import styled from 'styled-components';
import { FormattedAmount } from '../../../../../components';
import { StyledLabel, StyledText, Wrapper } from './styled';

const CurrentBidWrapper = styled.div`
  background-color: #3994de;
  color: #fff;
  border-radius: 2px;
  padding: 2px;
`;

// const Gap = styled.div`
//   padding-top: 8px;
// `;

export const AlternativeAuctionInfoBlock = ({ currentVehicle }) => {
  const sellerCounter = currentVehicle.active_alternative_offer?.amount;
  const buyerOffer = currentVehicle.top_alternative_bid_offer?.amount;

  return (
    <div>
      <Wrapper justifyBetween>
        <StyledLabel isBold>{'Current Offer:'}</StyledLabel>
        <StyledText>
          {buyerOffer ? (
            <CurrentBidWrapper>
              <FormattedAmount amount={buyerOffer} />
            </CurrentBidWrapper>
          ) : (
            '-'
          )}
        </StyledText>
      </Wrapper>
      <Wrapper justifyBetween>
        <StyledLabel>Counter to Buyers:</StyledLabel>
        <StyledText>{sellerCounter ? <FormattedAmount amount={sellerCounter} /> : '-'}</StyledText>
      </Wrapper>
      <Wrapper justifyBetween>
        <StyledLabel>Reserve</StyledLabel>
        <StyledText>
          {currentVehicle.reserve_price ? <FormattedAmount amount={currentVehicle.reserve_price} /> : '-'}
        </StyledText>
      </Wrapper>
      <Wrapper justifyBetween>
        <StyledLabel>Starting/Min Offer:</StyledLabel>
        <StyledText>
          <FormattedAmount amount={currentVehicle.starting_bid || 100} />
        </StyledText>
      </Wrapper>
      {/* <Gap /> */}
      {/* {!isVehicleTimerEnded ? (
        <ReservePriceLabel activeVehicle={currentVehicle} />
      ) : (
        <VehicleSoldLabel activeVehicle={currentVehicle} />
      )} */}
    </div>
  );
};
